export const DriverPricingModel = {
  INHERITED: "INHERITED",
  CUSTOM: "CUSTOM",
  DRIVER_TRUCK_TYPE: "DRIVER_TRUCK_TYPE",
  LOAD_TRUCK_TYPE_AVG: "LOAD_TRUCK_TYPE_AVG",
  LOAD_TRUCK_TYPE_MIN: "LOAD_TRUCK_TYPE_MIN",
  LOAD_TRUCK_TYPE_MAX: "LOAD_TRUCK_TYPE_MAX",
  NO_SUGGESTED_COST: "NO_SUGGESTED_COST",
} as const;

export type DriverPricingModel =
  (typeof DriverPricingModel)[keyof typeof DriverPricingModel];

export const DefaultDriverPricingModel = {
  DRIVER_TRUCK_TYPE: "DRIVER_TRUCK_TYPE",
  LOAD_TRUCK_TYPE_AVG: "LOAD_TRUCK_TYPE_AVG",
  LOAD_TRUCK_TYPE_MIN: "LOAD_TRUCK_TYPE_MIN",
  LOAD_TRUCK_TYPE_MAX: "LOAD_TRUCK_TYPE_MAX",
  NO_SUGGESTED_COST: "NO_SUGGESTED_COST",
} as const;

export type DefaultDriverPricingModel =
  (typeof DefaultDriverPricingModel)[keyof typeof DefaultDriverPricingModel];
